import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import {
    createMetSelectWrapper,
    MetSelectInput,
    MetSelectList,
} from 'topmeteo/general/components/MetSelectWrapper';

import {changeResolution} from 'topmeteo/general/actionCreators';

import ResolutionItem, {Resolutions, getLabel} from './ResolutionItem';
import ResolutionOptGroup, {isResolution, getResolution} from './ResolutionOptGroup';

const OptGroupLabel = _('Resolution');

export {ResolutionOptGroup, isResolution, getResolution};

const ResolutionSelect = ({value, onChange, ...props}) => (
    <div className="met-select-wrapper">
        <select className="met-select" value={value} onChange={onChange}>
            <optgroup label={OptGroupLabel}>
                {Resolutions.map(({label, ...resolution}) => <option {...resolution}>{label}</option>)}
            </optgroup>
        </select>
        <div className="styled-dropdown">
            <MetSelectInput {...props} value={getLabel(value)} />
            <MetSelectList>
                {Resolutions.map(resolution => <ResolutionItem {...resolution} />)}
            </MetSelectList>
        </div>
    </div>
);

const ResolutionSelectWrapper = createMetSelectWrapper(ResolutionSelect);

const mapStateToProps = ({resolution}) => ({value: resolution});

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(changeResolution(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResolutionSelectWrapper);
